<template>
  <div class="content main-container">
    <div class="search-tools">
      <div class="search-box btn3">
        <div class="input-item">
          <span class="label">对账单名称</span>
          <Input v-model="searchParams.reconciliationName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">对账类型</span>
          <lzDicSelect v-model="searchParams.reconciliationTypeList" :multiple="true" dicType="RECONCILIATION_TYPE" :transfer="true" clearable>
          </lzDicSelect>
        </div>
        <div class="input-item">
          <span class="label">核收人</span>
          <Input v-model="searchParams.reviewer" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">供应商类型</span>
          <RadioGroup v-model="searchParams.supplierType" @on-change="changeSupplierType">
            <Radio label="">全部</Radio>
            <Radio label="1">保险公司</Radio>
            <Radio label="2">合作通道</Radio>
          </RadioGroup>
        </div>
        <div class="input-item" v-if="searchParams.supplierType">
          <span class="label">供应商</span>
          <Select v-model="searchParams.supplierIds" multiple :max-tag-count="4" clearable filterable transfer>
            <Option :value="item.id" v-for="(item, index) in supplierList" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">开票日期</span>
          <DatePicker transfer :value="searchParams.date" @on-change="searchParams.date = $event" format="yyyy-MM-dd" type="daterange" placeholder="请选择">
          </DatePicker>
        </div>
        <div class="input-item">
          <span class="label">收款日期</span>
          <DatePicker transfer :value="searchParams.onedate" @on-change="searchParams.onedate = $event" format="yyyy-MM-dd" type="daterange" placeholder="请选择">
          </DatePicker>
        </div>

        <div class="btn-item">
          <Button type="primary" @click="getList()">查询</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
        </div>
      </div>
    </div>
    <div class="table-box">
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="reconciliationName">
          <span @click="detailPage(row)" class="toDetailPage">{{ row.reconciliationName }}</span>
        </template>
        <template slot-scope="{ row }" slot="billStatus">
          <span>{{ row.billStatus == 1 ? "已开票" : "未开票" }}</span>
        </template>
        <template slot-scope="{ row }" slot="returnedStatus">
          <span>{{ row.returnedStatus == 1 ? "已回款" : "未回款" }}</span>
        </template>
        <template slot-scope="{ row }" slot="inwardStatus">
          <span>{{ row.inwardStatus == 1 ? "已付款" : "未付款" }}</span>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <div class="detail">
            <div>
              <span style="margin-right: 10px;" v-if="row.billStatus == '0'" @click="detailPage(row, '1')">开票</span>
              <span style="margin-right: 10px;" v-if="row.returnedStatus == '0'" @click="detailPage(row, '2')">回款</span>
              <span style="margin-right: 10px;" v-if="row.inwardStatus == '0' && row.reconciliationType !=4 &&row.reconciliationType !=5" @click="detailPage(row, '3')">支付保费</span>
            </div>
          </div>
        </template>
      </Table>
      <div class="pageBox">
        <Page :total="total" :current="pageNo" :page-size="pageSize" show-total @on-change="pageChange"
          style="text-align: center" />
      </div>
    </div>
  </div>
</template>

<script>
import { pageTool } from "@/api/mixins";
import lzDicSelect from "@/components/commons/lzDicSelect";
export default {
  mixins: [pageTool],
  components: { lzDicSelect },
  data() {
    return {
      searchParams: {},
      supplierList: [],
      pageNo: 1,
      tableData: [],
      columns: [
        {
          title: "对账单名称",
          align: "center",
          slot: "reconciliationName",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "对账类型",
          align: "center",
          key: "reconciliationTypeDesc",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "总单量",
          align: "center",
          key: "countNum",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "总保费",
          align: "center",
          key: "premium",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "费用",
          align: "center",
          key: "commission",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "签约供应商",
          align: "center",
          key: "supplierName",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "签约机构",
          align: "center",
          key: "organizationName",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "核收人",
          align: "center",
          key: "reviewer",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "已开票？",
          align: "center",
          slot: "billStatus",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "已回款？",
          slot: "returnedStatus",
          width: 100,
          align: "center",
        },
        {
          slot: "inwardStatus",
          width: 100,
          align: "center",
          renderHeader: (h, params) => {
            return (
              <Tooltip
                trigger="hover"
                content="content"
                transfer={true}
              >
                <span>已付款</span>
                <span class="tip-icon">?</span>
                <div slot="content">
                  <span>代收保费是否已对上游付款</span>
                </div>
              </Tooltip>
            );
          }
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 180,
          fixed: "right",
        },
      ],
    }
  },
  activated() {
    this.getList()
  },
  methods: {
    // 获取列表数据
    getList(){
      if(this.searchParams.date&&this.searchParams.date.length>0){
        this.searchParams.startBillDate = this.searchParams.date[0]
        this.searchParams.endBillDate = this.searchParams.date[1]
      }
      if(this.searchParams.onedate&&this.searchParams.onedate.length>0){
        this.searchParams.startPaymentDate = this.searchParams.onedate[0]
        this.searchParams.endPaymentDate = this.searchParams.onedate[1]
      }
      
      this.$http({
        url: "/buz/commissionReconciliation/groupPolicy/list",
        type: "post",
        data: {
          reconciliationStatus: 3,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          ...this.searchParams
        }
      }).then(res=>{
        this.tableData = res.data;
        this.total = res.total;
      })
    },
    detailPage(row, height = 0) {
      this.$router.push({
        path: "/offline/groupReconciliationAccounts/detail",
        query: {
          id: row.id,
          height: height
        }
      })
    },
    // 分页
    pageChange(pageNo) {
      this.pageNo = pageNo;
      this.getList()
    },
    // 切换供应商类型
    changeSupplierType(value) {
      delete this.searchParams.supplierIds;
      this.supplierList = [];
      if (value == 1) {
        var url = '/buz/insuranceCompany/read/list'
      } else if (value == 2) {
        var url = '/buz/insuranceChannel/read/list'
      } else if (!value) {
        this.supplierList = [];
      }
      if (value) {
        this.$http({
          url,
          type: 'POST',
          data: {}
        }).then((res) => {
          this.supplierList = res.data;
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/.tip-icon {
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: transparent;
    border: 1px solid #000;
    color: #000;
    display: inline-block;
    text-align: center;
    line-height: 15px;
    font-size: 12px;
    cursor: pointer;
    top: 50%;
  }
.toDetailPage {
  color: #236DFF;
  cursor: pointer;
}

.search-tools {
  margin: 20px 0;
}

.table-box {
  margin-top: 20px;
}
</style>